import {StyleSheet} from 'react-native';
import {Colors} from '../../constants/Colors';

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: 'white',
    paddingHorizontal: 20,
    paddingVertical: 10,
  },
  containerHeader: {
    marginTop: 30,
    marginBottom: 20,
  },
  content: {
    paddingHorizontal: 20,
  },
  spaceHorizontal: {
    paddingHorizontal: 15,
    marginBottom: 20,
  },
  text: {
    alignSelf: 'flex-start',
    justifyContent: 'flex-start',
    textAlign: 'left',
    fontSize: 12,
    fontFamily: 'TCCC-UnityHeadline Regular',
    lineHeight: 16,
    color: 'black',
    marginBottom: 10,
  },
  errorText: {
    alignSelf: 'center',
    justifyContent: 'flex-start',
    textAlign: 'left',
    fontSize: 12,
    fontFamily: 'TCCC-UnityHeadline Regular',
    lineHeight: 16,
    color: 'red',
    marginBottom: 10,
  },
  titleDescription: {
    fontSize: 12,
    fontFamily: 'TCCC-UnityText Bold',
    lineHeight: 16,
    color: 'black',
    marginTop: 30,
    marginBottom: 15,
  },
  description: {
    fontSize: 10,
    fontFamily: 'TCCC-UnityHeadline Regular',
    lineHeight: 14,
    color: Colors.GrayPallete.lightgrayThree,
    marginTop: 10,
    maxWidth: 330,
  },
  containerButton: {
    width: '100%',
    height: 110,
    position: 'absolute',
    paddingHorizontal: 40,
    paddingRight: 80,
    bottom: 0,
    left: 0,
    right: 0,
    borderTopWidth: 1,
    borderColor: Colors.lightGray,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-evenly',
    backgroundColor: 'white',
  },
  textInput: {
    borderWidth: 1,
    borderColor: '#D10000',
    borderRadius: 5,
    padding: 10,
    color: 'black',
    marginHorizontal: 10,
    marginBottom: 50,
  },
  radioContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 10,
  },
  radio: {
    width: 20,
    height: 20,
    borderRadius: 10,
    borderWidth: 2,
    borderColor: '#D10000',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 10,
  },
  radioSelected: {
    width: 10,
    height: 10,
    borderRadius: 5,
    backgroundColor: '#D10000',
  },
  modalOverlay: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 30,
  },
  modalContainer: {
    backgroundColor: 'white',
    borderRadius: 8,
    width: '100%',
    maxWidth: 340,
    overflow: 'hidden',
  },
  modalContent: {
    paddingHorizontal: 24,
    paddingTop: 24,
    paddingBottom: 20,
    alignItems: 'center',
  },
  modalTitle: {
    fontSize: 16,
    fontFamily: 'TCCC-UnityText Bold',
    color: 'black',
    textAlign: 'center',
    marginBottom: 12,
  },
  modalMessage: {
    fontSize: 13,
    fontFamily: 'TCCC-UnityHeadline Regular',
    color: Colors.GrayPallete.grayOne,
    textAlign: 'center',
    lineHeight: 20,
  },
  modalButtons: {
    flexDirection: 'column',
    paddingHorizontal: 24,
    paddingBottom: 20,
    gap: 10,
  },
  modalButtonConfirm: {
    height: 40,
    backgroundColor: Colors.RedPallete.red,
    borderRadius: 3,
    alignItems: 'center',
    justifyContent: 'center',
  },
  modalButtonConfirmText: {
    fontSize: 14,
    fontFamily: 'TCCC-UnityText Bold',
    color: 'white',
    lineHeight: 16,
  },
  modalButtonCancel: {
    height: 40,
    borderWidth: 1,
    borderColor: Colors.RedPallete.red,
    borderRadius: 3,
    alignItems: 'center',
    justifyContent: 'center',
  },
  modalButtonCancelText: {
    fontSize: 14,
    fontFamily: 'TCCC-UnityText Bold',
    color: Colors.RedPallete.red,
    lineHeight: 16,
  },
});
